import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Check, Clock, AlertTriangle } from 'lucide-react';

const steps = [
    { stage: "Initiation projet", validator: "Laurent Caron", date: "15/06/2025", status: "validé", comment: "Projet conforme aux objectifs stratégiques" },
    { stage: "Validation budget", validator: "Philippe Durand", date: "18/06/2025", status: "validé", comment: "Budget approuvé avec réserve de contingence" },
    { stage: "Validation technique", validator: "Marie Rakoto", date: "En cours", status: "en_attente", comment: "Revue technique en cours" },
    { stage: "Validation direction", validator: "Jean Rakotoarison", date: "-", status: "a_venir", comment: "-" },
    { stage: "Validation finale", validator: "Sophie Ranaivo", date: "-", status: "a_venir", comment: "-" },
];

const statusConfig = {
    validé: { icon: Check, color: "bg-green-500", text: "text-green-800" },
    en_attente: { icon: Clock, color: "bg-yellow-500", text: "text-yellow-800" },
    a_venir: { icon: Clock, color: "bg-gray-300", text: "text-gray-500" },
};

// @ts-nocheck
export default function ValidationTab({ project }) {
    return (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <div className="lg:col-span-2 space-y-6">
                <div className="grid grid-cols-3 gap-6">
                    <Card className="shadow-lg border-0">
                        <CardContent className="p-6">
                            <p className="text-gray-500 mb-1">Étapes totales</p>
                            <p className="text-3xl font-bold">5</p>
                        </CardContent>
                    </Card>
                    <Card className="shadow-lg border-0">
                        <CardContent className="p-6">
                            <p className="text-gray-500 mb-1">Étapes validées</p>
                            <p className="text-3xl font-bold text-green-600">2</p>
                        </CardContent>
                    </Card>
                    <Card className="shadow-lg border-0">
                        <CardContent className="p-6">
                            <p className="text-gray-500 mb-1">En attente</p>
                            <p className="text-3xl font-bold text-yellow-600">3</p>
                        </CardContent>
                    </Card>
                </div>
                <Card className="shadow-lg border-0">
                    <CardHeader>
                        <CardTitle>Historique des validations</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="relative pl-8">
                            {steps.map((step, index) => {
                                const config = statusConfig[step.status];
                                const Icon = config.icon;
                                return (
                                    <div key={index} className="flex gap-6 pb-8">
                                        <div className="absolute left-0 flex flex-col items-center">
                                            <div className={`rounded-full h-8 w-8 flex items-center justify-center ${config.color}`}>
                                                <Icon className="h-5 w-5 text-white" />
                                            </div>
                                            {index < steps.length - 1 && (
                                                <div className="w-0.5 h-full bg-gray-200 mt-2"></div>
                                            )}
                                        </div>
                                        <div className="flex-1">
                                            <p className="font-semibold">{step.stage}</p>
                                            <p className="text-sm text-gray-500">Par {step.validator} - Le {step.date}</p>
                                            <p className="text-sm mt-1">{step.comment}</p>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </CardContent>
                </Card>
            </div>
            <div className="space-y-6">
                <Card className="shadow-lg border-0 bg-yellow-50">
                    <CardHeader>
                        <CardTitle className="flex items-center gap-2 text-yellow-800">
                            <AlertTriangle />
                            Actions requises
                        </CardTitle>
                    </CardHeader>
                    <CardContent>
                        <p className="font-semibold mb-2">Validation technique en attente</p>
                        <p className="text-sm text-gray-600 mb-4">Marie Rakoto doit valider les spécifications techniques.</p>
                        <div className="text-sm space-y-2 mb-4">
                            <p className="flex items-center gap-2"><Check className="w-4 h-4 text-green-600"/> Cahier des charges</p>
                            <p className="flex items-center gap-2"><Check className="w-4 h-4 text-green-600"/> Budget détaillé</p>
                            <p className="flex items-center gap-2"><Clock className="w-4 h-4 text-yellow-600"/> Rapport d'impact</p>
                        </div>
                        <Button className="w-full bg-teal-600 hover:bg-teal-700">Soumettre pour validation</Button>
                    </CardContent>
                </Card>
            </div>
        </div>
    );
}
